// app/javascript/utils/firebase/appChecl.js

import { app } from './initialise.js'; // Import the initialized Firebase app
import {
  initializeAppCheck, ReCaptchaV3Provider, getToken
} from 'firebase/app-check';

// Initialize Firebase Storage and associate it with your app
const recaptchaSiteKey ='6LedPQEqAAAAADwAEbDFIdOONwyKpedA3vh3iqj4';
// Initialize App Check (only if site key is provided)
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(recaptchaSiteKey),
  isTokenAutoRefreshEnabled: true
});

// Export the initialized storage instance AND common functions
// Exporting functions directly makes them easier to import elsewhere
export {
  appCheck,
  getToken,
};

console.log("Firebase AppCheck initialized.");
